var NotificationScheduleType;
(function (NotificationScheduleType) {
    NotificationScheduleType["DEFAULT"] = "Default";
    NotificationScheduleType["TIMETABLE"] = "Timetable";
    NotificationScheduleType["SPECIAL_DAYS"] = "SpecialDays";
})(NotificationScheduleType || (NotificationScheduleType = {}));
export default NotificationScheduleType;
